"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ItemSubList = exports.CreateItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _itemText = _interopRequireDefault(require("./item-text"));
var _virtualizedItems = _interopRequireDefault(require("./virtualized-items"));
var _styles = require("./styles");
const defaultProps = {
  items: [],
  placement: 'below',
  className: 'option-list'
};
const propTypes = {
  /**
   * The list of items that can be selected from: either a list of strings or a list of objects.
   */
  items: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.number])),
  /**
   * Maximum number of items to show. Items after this index will be cut off
   */
  maxItems: _propTypes.default.number,
  /**
   * Use categories, items will be put under a category based on the `category` member in each item
   */
  useCategories: _propTypes.default.bool,
  /**
   * The number of items; it's useful to have this when dealing with categories
   */
  itemsLength: _propTypes.default.number,
  /**
   * Function defining how the object should be rendered.
   * Only necessary when the list of items passed in are objects.
   * Example: if items are of the format {id: 1, text: 'apple'},
   * you would want itemToString to be: (item) => item ? item.text : ''
   */
  itemToString: _propTypes.default.func,
  /**
   * Function defining how each item should be rendered in the item list.
   * The signature of the function passed to itemToElement must be either:
   *   (item) => <Element />
   *     or
   *   (item, inputValue) => <Element />
   * The optional inputValue parameter may be useful when the component is uncontrolled;
   * it can be passed to the HighlightedText component for substring-match highlighting.
   * Note that while itemToElement is essentially a more powerful itemToString, a sensible itemToString
   * is still typically required in addition to itemToElement because itemToString is needed to:
   * populate the input upon selecting an item when the component is uncontrolled, to determine
   * whether the user can create an item when the component is in creatable mode, etc.
   */
  itemToElement: _propTypes.default.func,
  /**
   * Function for computing a unique key for each item, to make React happy. If unspecified,
   * itemToString will be used instead, which is preferable, but sometimes insufficient. For
   * example, the case where you have multiple items for which you want identical filtering
   * behavior for, but don’t necessarily render the same way (w/ itemToElement).
   */
  itemToKey: _propTypes.default.func,
  /**
   * A number that sets the max height of the dropdown in pixels
   * (e.g. 100)
   * If not all items fit within the set height,
   * the user will need to scroll to see the other options.
   */
  maxHeight: _propTypes.default.number,
  /**
   * An optional header node to include at the top of the open results container.
   * This is useful for placing specific options before other options in the list.
   */
  header: _propTypes.default.node,
  /**
   * An optional footer node to include at the bottom of the open results container.
   * This is useful for including things like the "powered by Google" image for location autocomplete.
   */
  footer: _propTypes.default.node,
  /**
   * Whether to truncate the text of an item to fit on a single line.
   */
  truncate: _propTypes.default.bool,
  /**
   * The currently highlighted index
   */
  highlightedIndex: _propTypes.default.number,
  /**
   * The current input value of the Select
   * Provided by downshift render prop
   */
  inputValue: _propTypes.default.string.isRequired,
  /**
   * Returns the props you should apply to any menu item elements you render.
   * Provided by downshift render prop
   */
  getItemProps: _propTypes.default.func.isRequired,
  /**
   * Use a text input to filter the options based on the entered text.
   */
  useTypeahead: _propTypes.default.bool,
  /**
   * If present, this is the dropdown text for the generated item used to create
   * a new option. Regardless of the form factor of the elements in the items
   * prop, this will always be a string.
   */
  createItemMessage: _propTypes.default.string,
  /**
   * Whether to virtualize the list.
   * Useful for lists with many elements that would otherwise slow down the page
   */
  virtualized: _propTypes.default.bool
};
const CreateItem = _ref => {
  let {
    showDivider,
    ...props
  } = _ref;
  return showDivider ? /*#__PURE__*/_react.default.createElement(_styles.ItemWithBorderTop, props) : /*#__PURE__*/_react.default.createElement(_styles.Item, props);
};
exports.CreateItem = CreateItem;
const ItemSubList = _ref2 => {
  let {
    items,
    maxItems,
    getItemProps,
    listIndexObject,
    itemToString,
    itemToElement,
    itemToKey,
    highlightedIndex,
    inputValue,
    truncate,
    useTypeahead
  } = _ref2;
  return (0, _map.default)(items).call(items, (item, localIndex) => {
    listIndexObject.index = listIndexObject.index + 1;
    const listIndex = listIndexObject.index;
    if (maxItems && localIndex >= maxItems) return;
    return /*#__PURE__*/_react.default.createElement(_styles.Item, (0, _extends2.default)({
      key: itemToKey ? itemToKey(item) : itemToString(item)
    }, getItemProps({
      item,
      index: listIndex,
      key: itemToKey ? itemToKey(item) : itemToString(item),
      isActive: highlightedIndex === listIndex
    })), itemToElement ? itemToElement(item, inputValue) : /*#__PURE__*/_react.default.createElement(_itemText.default, {
      inputValue: inputValue,
      truncate: truncate,
      useTypeahead: useTypeahead
    }, itemToString(item)));
  });
};
exports.ItemSubList = ItemSubList;
const ItemList = _ref3 => {
  let {
    items = [],
    itemsLength,
    maxItems,
    useCategories,
    itemToString,
    itemToElement,
    itemToKey,
    highlightedIndex,
    inputValue,
    getItemProps,
    maxHeight,
    header,
    footer,
    truncate,
    useTypeahead,
    createItemMessage,
    virtualized
  } = _ref3;
  if (virtualized) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_virtualizedItems.default, {
      items: items,
      maxHeight: maxHeight,
      inputValue: inputValue,
      getItemProps: getItemProps,
      itemToString: itemToString,
      itemToElement: itemToElement,
      itemToKey: itemToKey,
      highlightedIndex: highlightedIndex,
      useTypeahead: useTypeahead,
      truncate: truncate
    }), items.length > 0 && footer);
  } else {
    // Use an object here to carry the information between categories
    let listIndexObject = {
      index: -1
    };
    let categoriesAreLoading = false;
    const itemSubListProps = {
      getItemProps,
      listIndexObject,
      itemToString,
      itemToElement,
      itemToKey,
      highlightedIndex,
      inputValue,
      truncate,
      useTypeahead
    };
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (!useCategories && items.length > 0 || listIndexObject.index > -1 || createItemMessage) && header, useCategories ? (0, _map.default)(items).call(items, _ref4 => {
      let {
        category,
        items,
        loading,
        loadingMessage,
        maxItems
      } = _ref4;
      categoriesAreLoading = categoriesAreLoading || loading;
      return (!!items.length || loading) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: category
      }, /*#__PURE__*/_react.default.createElement(_styles.ItemCategory, null, category), loading ? /*#__PURE__*/_react.default.createElement(_styles.NoOptionsContainer, null, loadingMessage) : /*#__PURE__*/_react.default.createElement(ItemSubList, (0, _extends2.default)({
        items: items,
        maxItems: maxItems
      }, itemSubListProps)));
    }) : /*#__PURE__*/_react.default.createElement(ItemSubList, (0, _extends2.default)({
      items: items,
      maxItems: maxItems
    }, itemSubListProps)), createItemMessage && !categoriesAreLoading && /*#__PURE__*/_react.default.createElement(CreateItem, (0, _extends2.default)({}, getItemProps({
      item: inputValue,
      index: itemsLength,
      key: createItemMessage,
      isActive: highlightedIndex === itemsLength
    }), {
      showDivider: itemsLength > 0
    }), /*#__PURE__*/_react.default.createElement(_itemText.default, {
      truncate: truncate
    }, createItemMessage)), (!useCategories && items.length > 0 || listIndexObject.index > -1 || createItemMessage) && footer);
  }
};
ItemList.propTypes = propTypes;
ItemList.defaultProps = defaultProps;
var _default = exports.default = ItemList;
CreateItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CreateItem"
};
ItemList.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ItemList",
  "props": {
    "items": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "The list of items that can be selected from: either a list of strings or a list of objects.",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "object"
          }, {
            "name": "string"
          }, {
            "name": "number"
          }]
        }
      },
      "required": false
    },
    "placement": {
      "defaultValue": {
        "value": "'below'",
        "computed": false
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "'option-list'",
        "computed": false
      },
      "required": false
    },
    "maxItems": {
      "description": "Maximum number of items to show. Items after this index will be cut off",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "useCategories": {
      "description": "Use categories, items will be put under a category based on the `category` member in each item",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "itemsLength": {
      "description": "The number of items; it's useful to have this when dealing with categories",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "itemToString": {
      "description": "Function defining how the object should be rendered.\nOnly necessary when the list of items passed in are objects.\nExample: if items are of the format {id: 1, text: 'apple'},\nyou would want itemToString to be: (item) => item ? item.text : ''",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "itemToElement": {
      "description": "Function defining how each item should be rendered in the item list.\nThe signature of the function passed to itemToElement must be either:\n  (item) => <Element />\n    or\n  (item, inputValue) => <Element />\nThe optional inputValue parameter may be useful when the component is uncontrolled;\nit can be passed to the HighlightedText component for substring-match highlighting.\nNote that while itemToElement is essentially a more powerful itemToString, a sensible itemToString\nis still typically required in addition to itemToElement because itemToString is needed to:\npopulate the input upon selecting an item when the component is uncontrolled, to determine\nwhether the user can create an item when the component is in creatable mode, etc.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "itemToKey": {
      "description": "Function for computing a unique key for each item, to make React happy. If unspecified,\nitemToString will be used instead, which is preferable, but sometimes insufficient. For\nexample, the case where you have multiple items for which you want identical filtering\nbehavior for, but don\u2019t necessarily render the same way (w/ itemToElement).",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "maxHeight": {
      "description": "A number that sets the max height of the dropdown in pixels\n(e.g. 100)\nIf not all items fit within the set height,\nthe user will need to scroll to see the other options.",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "header": {
      "description": "An optional header node to include at the top of the open results container.\nThis is useful for placing specific options before other options in the list.",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "footer": {
      "description": "An optional footer node to include at the bottom of the open results container.\nThis is useful for including things like the \"powered by Google\" image for location autocomplete.",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "truncate": {
      "description": "Whether to truncate the text of an item to fit on a single line.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "highlightedIndex": {
      "description": "The currently highlighted index",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "inputValue": {
      "description": "The current input value of the Select\nProvided by downshift render prop",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "getItemProps": {
      "description": "Returns the props you should apply to any menu item elements you render.\nProvided by downshift render prop",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "useTypeahead": {
      "description": "Use a text input to filter the options based on the entered text.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "createItemMessage": {
      "description": "If present, this is the dropdown text for the generated item used to create\na new option. Regardless of the form factor of the elements in the items\nprop, this will always be a string.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "virtualized": {
      "description": "Whether to virtualize the list.\nUseful for lists with many elements that would otherwise slow down the page",
      "type": {
        "name": "bool"
      },
      "required": false
    }
  }
};